import { t } from '@lingui/core/macro';

export default function widthValidator(width: string | undefined) {
  if (width === '' || width === undefined) {
    return t`Ширина не может быть пустой`;
  }
  if (isNaN(Number(width))) {
    return t`Не удалось преобразовать ширину в число`;
  }
  if (+width <= 0) {
    return t`Ширина не может быть меньше или равна 0`;
  }
  if (+width >= 10000) {
    return t`Ширина не может быть больше или равна 10000`;
  }
  return undefined;
}
